import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CAL_CATEGORIES } from "../lib/constants";

const Dot = ({ c }) => <span className="w-3 h-3 rounded-sm inline-block mr-2 align-middle" style={{ background: c }} />;

export default function CategorySelect({ value, categories, onChange, testid }) {
  return (
    <Select value={value || "__auto"} onValueChange={(v) => onChange(v === "__auto" ? "" : v)}>
      <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent onCloseAutoFocus={(e) => e.preventDefault()}>
        <SelectItem value="__auto">Automatica (da tipo e squadra)</SelectItem>
        {CAL_CATEGORIES.filter((c) => c.key !== "green").map((c) => <SelectItem key={c.key} value={c.key}><Dot c={c.color} />{c.label}</SelectItem>)}
        {categories.map((c) => <SelectItem key={c.id} value={`c:${c.id}`}><Dot c={c.color} />{c.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
